import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-900 to-indigo-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {/* 会社情報 */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold mb-4">共伸機工株式会社</h2>
            <p className="flex items-center">
              <MapPin size={18} className="mr-2 text-blue-300" />
              〒975-0032 福島県南相馬市原町区桜井町1丁目4番地
            </p>
            <p className="flex items-center">
              <Phone size={18} className="mr-2 text-blue-300" />
              0244-25-4182
            </p>
            <p className="flex items-center">
              <Mail size={18} className="mr-2 text-blue-300" />
              m18021016@kyoshinkikou.jp
            </p>
          </div>

          {/* クイックリンクとロゴ */}
          <div className="flex flex-col items-end">
            <nav className="mb-6">
              <ul className="flex flex-wrap justify-end gap-4">
                <li><Link to="/" className="hover:text-blue-300 transition duration-300">ホーム</Link></li>
                <li><Link to="/company" className="hover:text-blue-300 transition duration-300">会社案内</Link></li>
                <li><Link to="/services" className="hover:text-blue-300 transition duration-300">修理サービス</Link></li>
                <li><Link to="/contact" className="hover:text-blue-300 transition duration-300">お問い合わせ</Link></li>
              </ul>
            </nav>
            <img src="/images/CompanyLogo.png" alt="共伸機工株式会社ロゴ" className="w-32 h-auto" />
          </div>
        </div>

        {/* 装飾的な区切り線 */}
        <div className="my-8 border-t border-blue-700 relative">
          <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-500 p-2 rounded-full">
            <div className="w-2 h-2 bg-white rounded-full"></div>
          </div>
        </div>

        {/* 著作権表示 */}
        <div className="text-center text-sm">
          <p>&copy; {new Date().getFullYear()} 共伸機工株式会社. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;